import sections from "fantastic/lib/sections";
import { collectItems } from "fantastic/lib/sections/collect";

export default (state = [], action) => {
  switch (action.type) {
    case "SECTIONS/ADD": {
      const { data, target } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));

      if (!target.id) {
        target.place === 'down' ? stateCopy.push(data) : stateCopy.unshift(data);
      } else {
        let destinationIndex = stateCopy.findIndex((item) => item.id === target.id);

        if (target.place === 'down') {
          destinationIndex += 1;
        }

        stateCopy.splice(destinationIndex, 0, data);
      }

      return sections.prepare(stateCopy);
    }
    case "SECTIONS/MOVE": {
      const { id, target } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));

      const sourceIndex = stateCopy.findIndex(item => item.id === id);
      let destinationIndex = stateCopy.findIndex(item => item.id === target.id);
      if (target.place === "down" && destinationIndex < sourceIndex) {
        destinationIndex = destinationIndex + 1;
      }
      if (target.place === "up" && destinationIndex > sourceIndex) {
        destinationIndex = destinationIndex - 1;
      }

      const [removed] = stateCopy.splice(sourceIndex, 1);
      stateCopy.splice(destinationIndex, 0, removed);

      return sections.prepare(stateCopy);
    }
    case "SECTIONS/MOVE_ITEM": {
      const { id, target } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));

      const sourceColumn = sections.columnByItemId(id, stateCopy);
      const sourceIndex = sourceColumn.items.findIndex(item => item.id === id);

      const destinationColumn = sections.columnByItemId(target.id, stateCopy);

      const [removed] = sourceColumn.items.splice(sourceIndex, 1);

      let destinationIndex;
      if (destinationColumn.items) {
        destinationIndex = destinationColumn.items.findIndex(
          item => item.id === target.id
        );
        if (target.place === "down") destinationIndex = destinationIndex + 1;
        destinationColumn.items.splice(destinationIndex, 0, removed);
      } else {
        destinationColumn.items = [removed];
      }

      return sections.prepare(stateCopy);
    }
    case "SECTIONS/ADD_ITEM": {
      const { data, target } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));

      const destinationColumn = sections.columnByItemId(target.id, stateCopy) || sections.byId(target.id, stateCopy);

      if (!destinationColumn) return state;

      let destinationIndex;
      if (destinationColumn.items) {
        destinationIndex = destinationColumn.items.findIndex(
          item => item.id === target.id
        );
        if (target.place === "down") destinationIndex = destinationIndex + 1;
        destinationColumn.items.splice(destinationIndex, 0, data);
      } else {
        destinationColumn.items = [data];
      }

      return sections.prepare(stateCopy);
    }

    case "SECTIONS/NODE/RESIZING": {
      const { id, resizing } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));
      let node = sections.byId(id, stateCopy);

      sections.collect(stateCopy, (_, item) => {
        if (item.meta.resizing) item.meta.resizing = false;
      });

      node.meta.resizing = resizing;

      return stateCopy;
    }

    case "SECTIONS/NODE/SELECTED": {
      const { id, selected } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));
      let node = sections.byId(id, stateCopy);

      sections.collect(stateCopy, (_, item) => {
        if (item.meta.selected) item.meta.selected = false;
      });

      if (node) node.meta.selected = selected;

      return stateCopy;
    }

    case "SECTIONS/NODE/TARGET": {
      const { id, target } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));
      let node = sections.byId(id, stateCopy);

      sections.collect(stateCopy, (_, item) => {
        if (item.meta.target) item.meta.target = false;
      });

      node.meta.target = target;

      return stateCopy;
    }

    case "SECTIONS/NODE/EDIT": {
      const { id, edit } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));
      let node = sections.byId(id, stateCopy);

      sections.collect(stateCopy, (_, item) => {
        if (item.meta.edit) item.meta.edit = false;
      });

      if (node && node.meta.editable) node.meta.edit = edit;

      return stateCopy;
    }

    case "SECTIONS/UPDATE": {
      const { id, data } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));

      let node = sections.byId(id, stateCopy);

      Object.assign(node, data);

      return sections.prepare(stateCopy, false);
    }
    case "SECTIONS/UPDATE_SECTION_COLUMNS": {
      const { id, sizes } = action.payload;
      if(!sizes) return state;

      const stateCopy = JSON.parse(JSON.stringify(state));

      let node = sections.byId(id, stateCopy);
      node.column = sizes[0];
      let parentNode = sections.byId(
        node.meta.parentNodes[node.meta.parentNodes.length - 1].id,
        stateCopy
      );
      let nextNodeIndex = parentNode.contents.indexOf(node) + 1;
      const nextColumn = parentNode.contents[nextNodeIndex];
      nextColumn.column = sizes[1];
      collectItems(node.items, (_, node) => {
        if (node.kind === "image") node.width = null;
      });
      collectItems(nextColumn.items, (_, node) => {
        if (node.kind === "image") node.width = null;
      });

      return sections.prepare(stateCopy);
    }
    case "SECTIONS/UPDATE_TABLE_COLUMNS": {
      const { id, index, width, nextWidth } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));

      let node = sections.byId(id, stateCopy);

      node.rows.forEach(row => {
        row.columns.forEach((column, columnIndex) => {
          if (columnIndex === index) column.width = width;
          if (columnIndex === index + 1) column.width = nextWidth;
        });
      });

      return sections.prepare(stateCopy);
    }

    case "SECTIONS/TABLE_ADD_CELL": {
      const { id, dir } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));

      let cell = sections.byId(id, stateCopy);
      let table_id = cell.meta.parentNodes[cell.meta.parentNodes.length - 1].id;
      let table = sections.byId(table_id, stateCopy);

      let cellIndex;
      table.rows.every(row => {
        if ((cellIndex = row.columns.indexOf(cell)) !== -1) return false;
        return true;
      });

      let halfWidth = cell.width / 2;

      table.rows.forEach(row => {
        row.columns.some((c, i) => {
          if (i === cellIndex) {
            c.width = halfWidth;
            return true;
          }
          return false;
        });
        row.columns.splice(cellIndex + (dir === "right" ? 1 : 0), 0, {
          width: halfWidth,
          items: []
        });
      });

      return sections.prepare(stateCopy);
    }

    case "SECTIONS/TABLE_REMOVE_CELL": {
      const { id, dir } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));

      let cell = sections.byId(id, stateCopy);
      let table_id = cell.meta.parentNodes[cell.meta.parentNodes.length - 1].id;
      let table = sections.byId(table_id, stateCopy);

      let cellIndex;

      if(table.rows.map(r => { return r.columns.length })[0] <= 1) {
        return state;
      }

      table.rows.every(row => {
        if ((cellIndex = row.columns.indexOf(cell)) !== -1) return false;
        return true;
      });

      let halfWidth = cell.width / 2;

      table.rows.forEach(row => {
        row.columns.every((c, i) => {
          if (i === cellIndex - 1 || i === cellIndex + 1) {
            c.width = c.width + halfWidth;
          }
          return false;
        });
        row.columns.splice(cellIndex, 1);
      });

      return sections.prepare(stateCopy);
    }

    case "SECTIONS/TABLE_ADD_ROW": {
      const { id, dir } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));

      let cell = sections.byId(id, stateCopy);
      let table_id = cell.meta.parentNodes[cell.meta.parentNodes.length - 1].id;
      let table = sections.byId(table_id, stateCopy);

      let rowIndex;

      table.rows.every((row, i) => {
        if (row.columns.indexOf(cell) !== -1) {
          rowIndex = i;
          return false;
        }
        return true;
      });

      let emptyRow = {
        columns: table.rows[rowIndex].columns.map(c => {
          return { items: [], width: c.width };
        })
      };

      table.rows.splice(rowIndex + (dir === "down" ? 1 : 0), 0, emptyRow);

      return sections.prepare(stateCopy);
    }

    case "SECTIONS/TABLE_REMOVE_ROW": {
      const { id, dir } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));

      let cell = sections.byId(id, stateCopy);
      let table_id = cell.meta.parentNodes[cell.meta.parentNodes.length - 1].id;
      let table = sections.byId(table_id, stateCopy);

      let rowIndex;

      if(table.rows.length <= 1) {
        return state;
      }

      table.rows.every((row, i) => {
        if (row.columns.indexOf(cell) !== -1) {
          rowIndex = i;
          return false;
        }
        return true;
      });

      table.rows.splice(rowIndex, 1);

      return sections.prepare(stateCopy);
    }

    case "SECTIONS/REMOVE": {
      const { id } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));

      const sourceIndex = stateCopy.findIndex(item => item.id === id);
      if (sourceIndex >= 0) {
        stateCopy.splice(sourceIndex, 1);
      } else {
        const sourceColumn = sections.columnByItemId(id, stateCopy);
        const sourceItemIndex = sourceColumn.items.findIndex(
          item => item.id === id
        );

        sourceColumn.items.splice(sourceItemIndex, 1);
      }

      return sections.prepare(stateCopy);
    }
    case "SECTIONS/CLONE": {
      const { id } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));

      const sourceIndex = stateCopy.findIndex(item => item.id === id);
      if (sourceIndex >= 0) {
        const cloneSection = JSON.parse(JSON.stringify(stateCopy[sourceIndex]));
        sections.collect([cloneSection], (_, node) => (node.id = null));
        stateCopy.splice(sourceIndex + 1, 0, cloneSection);
      } else {
        const sourceColumn = sections.columnByItemId(id, stateCopy);
        const sourceItemIndex = sourceColumn.items.findIndex(
          item => item.id === id
        );
        const cloneItem = JSON.parse(
          JSON.stringify(sourceColumn.items[sourceItemIndex])
        );
        collectItems([cloneItem], (_, node) => (node.id = null));

        sourceColumn.items.splice(sourceItemIndex + 1, 0, cloneItem);
      }

      return sections.prepare(stateCopy);
    }
    case "SECTIONS/REPLACE": {
      return sections.prepare(action.payload.replacementSections);
    }

    case "SECTIONS/NODE/DETERMINATE": {
      const { id, determinate } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));
      let node = sections.byId(id, stateCopy);

      if (node) node.meta.determinate = determinate;

      return stateCopy;
    }

    case "SECTIONS/PROMPT": {
      const { id, prompt } = action.payload;
      const stateCopy = JSON.parse(JSON.stringify(state));
      let node = sections.byId(id, stateCopy);

      if (node) node.meta.prompt = prompt;

      return stateCopy;
    }

    default: {
      return state;
    }
  }
};
